import _ from 'lodash';
import { v4 as UUID } from 'uuid';
import NodeBuilder from './NodeBuilder';
import SubsectionBuilder from './SubsectionBuilder';
import { isSectionBlueprint, } from '../../../types/questionnaireBlueprints/questionnaireBlueprints';
export default class SectionBuilder extends NodeBuilder {
    seedProviders;
    constructor(seedProviders) {
        super(seedProviders.forSection());
        this.node.sectionGroupKey = 'insuredPeople';
        this.seedProviders = seedProviders;
        this.node.id = UUID();
    }
    with(nodeBuilder) {
        if (nodeBuilder instanceof SubsectionBuilder) {
            return this.withSubsections(nodeBuilder);
        }
        return this.withSubsections(this.childBuilder().with(nodeBuilder));
    }
    withSubsections(subsectionBuilders) {
        const builders = subsectionBuilders ? _.castArray(subsectionBuilders) : [];
        if (builders.length === 0) {
            builders.push(this.childBuilder());
        }
        const subsections = builders.map((builder) => builder.build());
        this.addSubsections(subsections);
        return this.clone();
    }
    withFieldGroups(fieldGroupBuilders) {
        this.addSubsections(this.childBuilder().withFieldGroups(fieldGroupBuilders).build());
        return this.clone();
    }
    withFields(fieldBuilders) {
        this.addSubsections(this.childBuilder().withFields(fieldBuilders).build());
        return this.clone();
    }
    addSubsections(subsections) {
        if (!this.node.subsections)
            this.node.subsections = [];
        const subsectionList = _.castArray(subsections);
        this.node.subsections.push(...subsectionList);
    }
    childBuilder() {
        return new SubsectionBuilder(this.seedProviders);
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    withPartName(partname) {
        this.node.partName = partname;
        return this.clone();
    }
    withSectionGroupKey(sectionGroupKey) {
        this.node.sectionGroupKey = sectionGroupKey;
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    visibleIf(condition) {
        this.node.visible = condition;
        return this.clone();
    }
    validate(section) {
        return isSectionBlueprint(section);
    }
}
